import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvConfigService } from '../services/env-config.service';

export const apiUrlInterceptor: HttpInterceptorFn = (req, next) => {
    const envConfig = inject(EnvConfigService);
    if (!req.url.startsWith('/api/') || !envConfig.apiUrl) {
        return next(req);
    }
    return next(req.clone({ url: `${envConfig.apiUrl}${req.url}` }));
};
